export const EXPECTED_TIMES = [
  {
    id: 'NONE',
    name: '',
  },
  {
    id: 'FEW_HOURS_MONTH',
    name:
      /* TRANSLATORS: expected time */
      getText('A few hours per month'),
  },
  {
    id: 'FEW_HOURS_WEEK',
    name:
      /* TRANSLATORS: expected time */
      getText('A few hours per week'),
  },
  {
    id: 'PART_TIME',
    name:
      /* TRANSLATORS: expected time */
      getText('Part time (10-30 hrs/wk)'),
  },
  {
    id: 'FULL_TIME',
    name:
      /* TRANSLATORS: expected time */
      getText('Full time (30+ hrs/wk)'),
  },
];
